export default "__VITE_ASSET__CXpWFSyt__"